//// WARNING: This file is auto-generated. Do not modify here
import { PhraseKey, PhraseDefinition } from "@atgof-common/phrases/types";

export const languages = ["en", "cy"];
export const phrases: Record<PhraseKey, PhraseDefinition> = {
  "language-label": { en: "English", cy: "Cymraeg" },
  "app-name": { default: "Atgof" },
  "website-short": { default: "atgof.app" },
  "log-in-to-app": { en: "Sign in to Atgof", cy: "Mewngofnodi i Atgof" },
  settings: { en: "Settings", cy: "Dewisiadau" },
  language: { en: "Language", cy: "Iaith" },
  loading: { en: "Loading\u2026", cy: "Wrthi\u2019n llwytho\u2026" },
  "unexpected-error": { en: "Unexpected Error", cy: "Gwall Annisgwyl" },
  "toplevel-unexpected-error-prompt": {
    en: "Please re-open Atgof.",
    cy: "Bydd angen ail-agor Atgof.",
  },
  "unexpected-error-prompt": {
    en: "Try going back to another page or re-opening Atgof.",
    cy: "Rhowch dro ar fynd n\u00f4l i dudalen arall neu ail-agor Atgof.",
  },
  "re-open": { en: "Re-open", cy: "Ail-agor" },
  "enter-login-details-prompt": {
    en: "Enter your email address to sign in",
    cy: "Defnyddiwch eich cyfeiriad ebost i fewngofnodi",
  },
  "log-in-prompt": {
    en: "Tap a button below and then follow any instructions to sign in",
    cy: "Tapiwch fotwm isod ac yna dilyn unrhyw gyfarwyddiadau i fewngofnodi",
  },
  name: { en: "Name", cy: "Enw" },
  email: { en: "Email", cy: "Ebost" },
  phone: { en: "Phone", cy: "Ff\u00f4n" },
  address: { en: "Address", cy: "Cyfeiriad" },
  "invalid-email-warning": {
    en: "Enter a valid address",
    cy: "Rhaid rhoi cyfeiriad dilys",
  },
  password: { en: "Password", cy: "Cyfrinair" },
  "empty-password-warning": {
    en: "Enter a password",
    cy: "Rhaid rhoi eich cyfrinair",
  },
  "log-in-with-google": {
    en: "Sign In with Google",
    cy: "Mewngofnodi \u00e2 Google",
  },
  "log-in-with-microsoft": {
    en: "Sign In with Microsoft",
    cy: "Mewngofnodi \u00e2 Microsoft",
  },
  "log-in-with-apple": { en: "Sign In with Apple", cy: "Mewngofnodi ag Apple" },
  "log-out": { en: "Sign Out", cy: "Allgofnodi" },
  "logging-in": { en: "Signing in", cy: "Wrthi\u2019n mewngofnodi" },
  "checking-account": { en: "Checking account", cy: "Gwirio\u2019r cyfrif" },
  "login-failed": { en: "Unable to sign in", cy: "Nid oedd modd mewngofnodi" },
  "login-cancelled": {
    en: "The sign-in process was cancelled",
    cy: "Cafodd y mewngofnodi ei ganslo",
  },
  "check-email-and-password": {
    en: "Make sure you entered your email address and password correctly.",
    cy: "Sicrhewch bod eich cyfeiriad ebost a\u2019ch cyfrinair yn gywir.",
  },
  "login-failed-with-reason": {
    en: "Unable to sign in. The service provided the following reason:",
    cy: "Nid oedd modd mewngofnodi. Dyma\u2019r gwall gan y gwasanaeth:",
  },
  "unable-to-load": { en: "Unable to load Atgof", cy: "Methu llwytho Atgof" },
  "unable-to-load-with-reason": {
    en: "Atgof couldn\u2019t be loaded. The service provided the following reason:",
    cy: "Nid oedd modd llwytho Atgof. Dyma\u2019r gwall gan y gwasanaeth:",
  },
  "verify-your-email": {
    en: "Verify your Email Address",
    cy: "Gwiriwch eich Cyfeiriad Ebost",
  },
  "verify-your-email-prompt": {
    en: "You\u2019ll need to verify your email address before you can join projects",
    cy: "Bydd angen gwirio\u2019ch cyfeiriad ebost cyn medru ymuno \u00e2 phrojectau",
  },
  "verification-sent-prompt": {
    en: (m) =>
      "We\u2019ve sent an email to " +
      m.email +
      ". Please check your Inbox and Spam, and follow the instructions in the email message to verify your address.",
    cy: (m) =>
      "Rydym wedi anfon ebost at " +
      m.email +
      ". Edrychwch yn eich Mewnflwch \u00e2\u2019ch Sbam, a dilyn y cyfarwyddiadau yn y neges ebost er mwyn gwirio\u2019ch cyfeiriad.",
  },
  "unable-to-send-verification": {
    en: "We weren\u2019t able to send you a verification email.",
    cy: "Nid oedd modd ini anfon ebost atoch.",
  },
  "verify-now": { en: "Verify Now", cy: "Gwirio Nawr" },
  "invitations-failed-with-reason": {
    en: "Unable to load any invitations. The service provided the following reason:",
    cy: "Nid oedd modd llwytho unrhyw wahoddiadau. Dyma\u2019r gwall gan y gwasanaeth:",
  },
  "unable-to": { en: "Unable to", cy: "Methu" },
  "unable-to-perform-action": {
    en: "Unable to perform action",
    cy: "Methu cyflawni\u2019r weithred",
  },
  dismiss: { en: "Dismiss", cy: "Diddymu" },
  "try-again": { en: "Please try again.", cy: "Rhowch gynnig arall arni." },
  "try-again-later": {
    en: "Please try again later.",
    cy: "Rhowch gynnig arall ymhen ychydig.",
  },
  "create-account": { en: "Create Account", cy: "Creu Cyfrif Newydd" },
  "new-invitation": { en: "New Invitation", cy: "Gwahoddiad Newydd" },
  "new-member": { en: "New Member", cy: "Aelod Newydd" },
  "invited-to-join": {
    en: "You are invited to join",
    cy: "Gwahoddiad i ymuno \u00e2",
  },
  "a-project": { en: "a project", cy: "project" },
  "other-projects": { en: "Other Projects", cy: "Projectau Eraill" },
  accept: { en: "Accept", cy: "Derbyn" },
  "create-invitation": { en: "create invitation", cy: "creu gwahoddiad" },
  "accept-invitation": { en: "accept invitation", cy: "derbyn gwahoddiad" },
  "join-a-project": { en: "Join a Project", cy: "Ymuno \u00e2 Project" },
  "no-invitations-explanation": {
    en: (m) =>
      "Please ask your team to invite " +
      m.email +
      " to the project you\u2019re working on.",
    cy: (m) =>
      "Gofynnwch i\u2019ch t\u00eem wahodd " +
      m.email +
      " i\u2019r project rydych yn gweithio arno.",
  },
  "no-invitations-next-step": {
    en: "Once they\u2019ve done that, an invitation will appear here for you to accept.",
    cy: "Unwaith mae hynny wedi\u2019i wneud, bydd eich gwahoddiad yn ymddangos yma.",
  },
  "id-token-required-error": {
    en: "Unable to authenticate your account. Please sign out and sign in again.",
    cy: "Nid oedd modd dilysu eich cyfrif. Ceisiwch allgofnodi a mewngofnodi eto.",
  },
  "provider-not-supported-by-project-error": {
    en: (m) =>
      m.projectName +
      " doesn\u2019t allow access to users who are signed in via " +
      m.providerName +
      ". " +
      "Please sign in via " +
      m.supportedProviderList,
    cy: (m) =>
      "Nid yw " +
      m.projectName +
      " yn caniat\u00e1u mynediad i ddefnyddwyr trwy " +
      m.providerName +
      ". " +
      "Ceisiwch fewngofnodi efo " +
      m.supportedProviderList,
  },
  "project-requires-mfa": {
    en: (m) =>
      "You\u2019ll need to add an authentication factor in order to access " +
      m.projectName,
    cy: (m) =>
      "Rhaid ychwanegu ffactor awthentigeiddio er mwyn medru cael mynediad i " +
      m.projectName,
  },
  "camera-permission-required-error": {
    en: "Atgof requires permission to access the camera",
    cy: "Mae angen caniat\u00e2d ar Atgof",
  },
  "library-permission-required-error": {
    en: "Atgof requires permission to access your photo library",
    cy: "Mae angen caniat\u00e2d ar Atgof er mwyn dod o hyd i luniau",
  },
  search: { en: "Search", cy: "Chwilio" },
  edit: { en: "Edit", cy: "Golygu" },
  other: { en: "Other\u2026", cy: "Arall\u2026" },
  select: { en: "Select", cy: "Dethol" },
  "select-all": { en: "Select All", cy: "Dethol Popeth" },
  selected: { en: "selected", cy: "wedi dethol" },
  ignore: { en: "Ignore", cy: "Anwybyddu" },
  save: { en: "Save", cy: "Arbed" },
  undo: { en: "Undo", cy: "Dadwneud" },
  "deleted-an-item": { en: "Deleted an item", cy: "Wedi dileu eitem" },
  done: { en: "Done", cy: "Iawn" },
  add: { en: "Add", cy: "Ychwanegu" },
  create: { en: "Create", cy: "Creu" },
  delete: { en: "Delete", cy: "Dileu" },
  cancel: { en: "Cancel", cy: "Canslo" },
  until: { en: "until", cy: "tan" },
  sheets: { en: "Sheets", cy: "Dalennau" },
  by: { en: "by", cy: "yn \u00f4l" },
  since: { en: "Since", cy: "Ers" },
  date: { en: "Date", cy: "Dyddiad" },
  "recent-sheets": { en: "Recent Sheets", cy: "Dalennau Diweddar" },
  "my-sheets": { en: "My Sheets", cy: "Fy Nalennau" },
  "my-recent-sheets": { en: "My Recent Sheets", cy: "Fy Nalennau Diweddar" },
  "new-sheet": { en: "New Sheet", cy: "Dalen Newydd" },
  "edit-sheet": { en: "Edit Sheet", cy: "Golygu Dalen" },
  "new-arts-sheet": { en: "New Arts Sheet", cy: "Dalen Gelf Newydd" },
  "new-arts-look": { en: "New Arts Look", cy: "Gwedd Celf Newydd" },
  "new-makeUp-sheet": { en: "New Make-up Sheet", cy: "Dalen Golur Newydd" },
  "new-wardrobe-sheet": { en: "New Wardrobe Sheet", cy: "Dalen Wisg Newydd" },
  "new-makeUp-look": { en: "New Make-up Look", cy: "Gwedd Colur Newydd" },
  "new-wardrobe-look": { en: "New Wardrobe Look", cy: "Gwedd Gwisg Newydd" },
  "new-makeUp-item": { en: "New Make-up Item", cy: "Eitem Colur Newydd" },
  "new-wardrobe-item": { en: "New Wardrobe Item", cy: "Eitem Gwisg Newydd" },
  "new-pa-sheet": { en: "New PA Sheet", cy: "Dalen PA Newydd" },
  projects: { en: "Projects", cy: "Projectau" },
  invitation: { en: "Invitation", cy: "Gwahoddiad" },
  invitations: { en: "Invitations", cy: "Gwahoddiadau" },
  member: { en: "Member", cy: "Aelod" },
  members: { en: "Members", cy: "Aelodau" },
  roles: { en: "Roles", cy: "Hawliau" },
  role: { en: "Role", cy: "Swyddogaeth" },
  contact: { en: "Contact", cy: "Cyswllt" },
  "ink-colours": { en: "Ink Colours", cy: "Lliwiau Inc" },
  "on-dark-background": { en: "On dark background", cy: "Ar gefndir tywyll" },
  "on-light-background": { en: "On light background", cy: "Ar gefndir golau" },
  none: { en: "None", cy: "Dim" },
  "normal-user": { en: "Normal user", cy: "Defnyddiwr cyffredin" },
  "admin-user": { en: "Admin user", cy: "Defnyddiwr gweinyddol" },
  "notify-email-for-scene-changes": {
    en: "Notify via email if changes are made to a scene",
    cy: "Hysbysu dros ebost pan mae golyga\u2019n cael ei newid",
  },
  users: { en: "Users", cy: "Defnyddwyr" },
  seasons: { en: "Seasons", cy: "Cyfresi" },
  sets: { en: "Sets", cy: "Setiau" },
  characters: { en: "Characters", cy: "Cymeriadau" },
  "supporting-artists-short": { en: "SAs", cy: "SAs" },
  "stunt-performers": { en: "Stunt Performers", cy: "Styntmyn" },
  start: { en: "Start", cy: "Dechrau" },
  finish: { en: "Finish", cy: "Gorffen" },
  episodes: { en: "Episodes", cy: "Penodau" },
  category: { en: "Category", cy: "Categori" },
  admin: { en: "Admin", cy: "Gweinyddol" },
  arts: { en: "Arts", cy: "Celf" },
  makeUp: { en: "Make-up", cy: "Colur" },
  wardrobe: { en: "Wardrobe", cy: "Gwisg" },
  pa: { en: "PA", cy: "PA" },
  "script-supervisor": { en: "Script Supervisor", cy: "Goruchwyliwr Sgript" },
  director: { en: "Director", cy: "Cyfarwyddwr" },
  postProduction: { en: "Post-production", cy: "\u00d4l-gynhyrchu" },
  postProductionDirector: {
    en: "Post-production Director",
    cy: "Cyfarwyddwr \u00d4l-gynhyrchu",
  },
  postProductionSFX: { en: "Post-production SFX", cy: "SFX \u00d4l-gynhyrchu" },
  soundSupervisor: { en: "Sound Supervisor", cy: "Goruchwyliwr Sain" },
  directorOfPhotography: {
    en: "Director of Photography",
    cy: "Cyfarwyddwr Ffotograffiaeth",
  },
  dop: { en: "DoP", cy: "DoP" },
  lightingGaffer: { en: "Lighting Gaffer", cy: "Giaffar Goleuo" },
  cateringManager: { en: "Catering Manager", cy: "Rheolwr Arlwyo" },
  wellbeingFacilitator: { en: "Well-being Facilitator", cy: "Hwylusydd Lles" },
  dubbingMixer: { en: "Dubbing Mixer", cy: "Cymathydd Sain" },
  editor: { en: "Editor", cy: "Golygydd" },
  project: { en: "Project", cy: "Project" },
  production: { en: "Production", cy: "Cynhyrchiad" },
  all: { en: "All", cy: "Popeth" },
  character: { en: "Character", cy: "Cymeriad" },
  set: { en: "Set", cy: "Set" },
  "count-season": {
    en: (m) => (m.count == 1 ? "season" : "seasons"),
    cy: (m) => (m.count == 2 ? "gyfres" : m.count == 0 ? "cyfresi" : "cyfres"),
  },
  season: { en: "Season", cy: "Cyfres" },
  series: { en: "Series", cy: "Cyfres" },
  "filming-starts": { en: "Filming Starts", cy: "Dechrau Ffilmio" },
  "filming-ends": { en: "Filming Ends", cy: "Gorffen Ffilmio" },
  "count-episode": {
    en: (m) => (m.count == 1 ? "episode" : "episodes"),
    cy: (m) => (m.count == 2 ? "bennod" : m.count == 0 ? "penodau" : "pennod"),
  },
  episode: { en: "Episode", cy: "Pennod" },
  "episode-number": { en: "Episode number", cy: "Rhif y bennod" },
  ep: { en: "Ep", cy: "Pen" },
  "zero-count": { en: "No", cy: "Dim" },
  "count-scene": {
    en: (m) => (m.count == 1 ? "scene" : "scenes"),
    cy: (m) =>
      m.count == 2 ? "olygfa" : m.count == 0 ? "golygfeydd" : "golygfa",
  },
  "count-part": {
    en: (m) => (m.count == 1 ? "part" : "parts"),
    cy: (m) => (m.count == 2 ? "ran" : m.count == 0 ? "rhannau" : "rhan"),
  },
  "does-not-exist-prompt": {
    en: (m) => m.entityDescription + " does not exist",
    cy: (m) => "Nid yw " + m.entityDescription + " yn bodoli",
  },
  scene: { en: "Scene", cy: "Golygfa" },
  scenes: { en: "Scenes", cy: "Golygfeydd" },
  "part-of": { en: "Part of", cy: "Rhan o" },
  "runs-into": { en: "Runs into", cy: "Rhedeg mewn i" },
  completed: { en: "Completed", cy: "Cyflawn" },
  remaining: { en: "Remaining", cy: "Gweddill " },
  isComplete: { en: "Complete", cy: "Cyflawn" },
  isDropped: { en: "Dropped", cy: "Gollwng" },
  actions: { en: "Tasks", cy: "Tasgau" },
  isDone: { en: "Done", cy: "Gorffen" },
  description: { en: "Description", cy: "Disgrifiad" },
  end: { en: "End", cy: "Diwedd" },
  tx: { en: "TX", cy: "TX" },
  "tx-date": { en: "TX Date", cy: "Darlledu" },
  director: { en: "Director", cy: "Cyfarwyddwr" },
  "director-short": { en: "Dir.", cy: "Cyf." },
  scriptwriter: { en: "Scriptwriter", cy: "Sgriptiwr" },
  cast: { en: "Cast", cy: "Cast" },
  actor: { en: "Actor", cy: "Actor" },
  supportingArtist: { en: "Supporting Artist", cy: "Ecstra" },
  chaperone: { en: "Chaperone", cy: "Tywysydd" },
  producer: { en: "Producer", cy: "Cynhyrchydd" },
  executiveProducer: { en: "Executive Producer", cy: "Uwch Gynhyrchydd" },
  productionManager: { en: "Production Manager", cy: "Rheolwr Cynhyrchu" },
  productionCoordinator: {
    en: "Production Co-ordinator",
    cy: "Cydlynydd Cynhyrchu",
  },
  "1stAssistantDirector": { en: "1st AD", cy: "1st AD" },
  "2ndAssistantDirector": { en: "2nd AD", cy: "2nd AD" },
  "3rdAssistantDirector": { en: "3rd AD", cy: "3rd AD" },
  runner: { en: "Runner", cy: "Rhedwr" },
  locationManager: { en: "Location Manager", cy: "Rheolwr Lleoliadau" },
  artSupervisor: { en: "Art Supervisor", cy: "Goruchwyliwr Celf" },
  artAssistant: { en: "Art Assistant", cy: "Cynorthwyydd Celf" },
  designer: { en: "Designer", cy: "Cynllunydd" },
  graphicDesigner: { en: "Graphic Designer", cy: "Dylunydd Graffeg" },
  fightDirector: { en: "Fight Director", cy: "Cyfarwyddwr yr Ymladd" },
  intimacyCoordinator: {
    en: "Intimacy Co-ordinator",
    cy: "Cydlynydd Agosatrwydd",
  },
  sustainabilityCoordinator: {
    en: "Sustainability Co-ordinator",
    cy: "Cydlynydd Cynaliadwyedd",
  },
  animalHandler: { en: "Animal Handler", cy: "Arbenigwr Trin Anifeiliaid" },
  wardrobeSupervisor: { en: "Wardrobe Supervisor", cy: "Goruchwyliwr Gwisg" },
  wardrobeAssistant: { en: "Wardrobe Assistant", cy: "Cynorthwyydd Gwisg" },
  makeUpSupervisor: { en: "Make-up Supervisor", cy: "Goruchwyliwr Colur" },
  makeUpAssistant: { en: "Make-up Assistant", cy: "Cynorthwyydd Colur" },
  synopsis: { en: "Synopsis", cy: "Crynodeb" },
  "filming-date": { en: "Filming Date", cy: "Dyddiad Filmio" },
  "filming-day": { en: "Filming Day", cy: "Diwrnod Ffilmio" },
  interior: { en: "Interior", cy: "Mewn" },
  exterior: { en: "Exterior", cy: "Allan" },
  "int-ext": { en: "Int\/Ext", cy: "Me\/All" },
  int: { en: "Int", cy: "Me" },
  ext: { en: "Ext", cy: "All" },
  tod: { en: "ToD", cy: "Adeg" },
  "day-ordinal": { en: "Day", cy: "Diwrnod" },
  "day-ordinal-abbrev": { en: "D", cy: "D" },
  days: { en: "Days", cy: "Diwrnodau" },
  "story-day": { en: "Story Day", cy: "Dydd Stori" },
  "story-days": { en: "Story Days", cy: "Dyddiau Stori" },
  "day-month": { en: "Day\/Month", cy: "Diwrnod\/Mis" },
  "day-of-week": { en: "Day of Week", cy: "Diwrnod yr Wythnos" },
  day: { en: "Day", cy: "Dydd" },
  "d-n": { en: "D\/N", cy: "D\/N" },
  night: { en: "Night", cy: "Nos" },
  dawn: { en: "Dawn", cy: "Gwawr" },
  dusk: { en: "Dusk", cy: "Cyfnos" },
  page: { en: "Page", cy: "Tudalen" },
  pages: { en: "Pages", cy: "Tudalennau" },
  "page-count": { en: "Page Count", cy: "Tudalennau" },
  notes: { en: "Notes", cy: "Nodiadau" },
  "scene-notes": { en: "Scene Notes", cy: "Nodiadau Golygfa" },
  "photo-notes": { en: "Photo Notes", cy: "Nodiadau Llun" },
  extras: { en: "Extras", cy: "Ecstras" },
  "makeUp-sheet": { en: "Make-up Sheet", cy: "Dalen Colur" },
  "choose...": { en: "Choose\u2026", cy: "Dewis\u2026" },
  photos: { en: "Photos", cy: "Lluniau" },
  photo: { en: "Photo", cy: "Llun" },
  looks: { en: "Looks", cy: "Gweddau" },
  "based-on": { en: "Based on", cy: "Seilio ar" },
  change: { en: "Change", cy: "Newid" },
  look: { en: "Look", cy: "Gwedd" },
  "episode-looks": { en: "Episode Looks", cy: "Gweddau Pennod" },
  "story-day-looks": { en: "Story Day Looks", cy: "Gweddau Dydd Stori" },
  "episode-look": { en: "Episode Look", cy: "Gwedd Pennod" },
  "story-day-look": { en: "Story Day Look", cy: "Gwedd Dydd Stori" },
  "new-look": { en: "New Look", cy: "Gwedd Newydd" },
  "unnamed-look": { en: "[ Unnamed Look ]", cy: "[ Gwedd Di-enw ]" },
  "look-name": { en: "Look Name", cy: "Enw Gwedd" },
  "look-description": { en: "Look Description", cy: "Disgrifiad Gwedd" },
  items: { en: "Items", cy: "Eitemau" },
  props: { en: "Props", cy: "Props" },
  prop: { en: "Prop", cy: "Prop" },
  "new-prop": { en: "New Prop", cy: "Prop Newydd" },
  "unnamed-prop": { en: "[ Unnamed Prop ]", cy: "[ Prop Di-enw ]" },
  "prop-name": { en: "Prop Name", cy: "Enw Prop" },
  "prop-description": { en: "Prop Description", cy: "Disgrifiad Prop" },
  "new-item": { en: "New Item", cy: "Eitem Newydd" },
  "unnamed-item": { en: "[ Unnamed Item ]", cy: "[ Eitem Di-enw ]" },
  "item-name": { en: "Item Name", cy: "Enw Eitem" },
  "item-description": { en: "Item Description", cy: "Disgrifiad Eitem" },
  "makeUp:notes": { en: "Notes", cy: "Nodiadau" },
  "makeUp:other": { en: "Other", cy: "Arall" },
  "makeUp:primer": { en: "Primer", cy: "Preimiwr" },
  "makeUp:base": { en: "Base", cy: "Sylfaen" },
  "makeUp:concealer": { en: "Concealer", cy: "Cuddiwr" },
  "makeUp:blusher": { en: "Blusher", cy: "Powdwr Gwrido" },
  "makeUp:powder": { en: "Powder", cy: "Powdwr" },
  "makeUp:eyeshadow": { en: "Eyeshadow", cy: "Colur Llygaid" },
  "makeUp:eyeliner-top": { en: "Eye-liner Top", cy: "Pensel Linellu Top" },
  "makeUp:eyeliner-bottom": {
    en: "Eye-liner Bottom",
    cy: "Pensel Linellu Gwaelod",
  },
  "makeUp:mascara": { en: "Mascara", cy: "Masgara" },
  "makeUp:eyebrows": { en: "Eyebrows", cy: "Aeliau" },
  "makeUp:lips": { en: "Lips", cy: "Gwefusau" },
  "makeUp:nails": { en: "Nails", cy: "Ewinedd" },
  "makeUp:makeup-notes": { en: "Make-up Notes", cy: "Nodiadau Colur" },
  hair: { en: "Hair", cy: "Gwallt" },
  "makeUp:hair-notes": { en: "Hair Notes", cy: "Nodiadau Gwallt" },
  "makeUp:hair-products": { en: "Hair Products", cy: "Cynhyrchion Gwallt" },
  "makeUp:finishing-product": {
    en: "Finishing Product",
    cy: "Cynnyrch Gorffennu",
  },
  "makeUp:hair-accessories": { en: "Hair Accessories", cy: "Ategolion Gwallt" },
  "wardrobe:tops": { en: "Tops", cy: "Topiau" },
  "wardrobe:bottoms": { en: "Bottoms", cy: "Gwaelodion" },
  "wardrobe:footwear": { en: "Footwear", cy: "Esgidiau" },
  "wardrobe:outerwear": { en: "Outerwear", cy: "Dillad Uchaf" },
  "wardrobe:accessories": { en: "Accessories", cy: "Ategolion" },
  jewellery: { en: "Jewellery", cy: "Gemwaith" },
  "wardrobe:notes": { en: "Notes", cy: "Nodiadau" },
  "arts:action-props": { en: "Action Props", cy: "Props Llaw" },
  "arts:dressing-props": { en: "Dressing Props", cy: "Props Set" },
  "arts:food": { en: "Food", cy: "Bwyd" },
  "arts:vehicles": { en: "Vehicles", cy: "Cerbydau" },
  "arts:animals": { en: "Animals", cy: "Anifeiliaid" },
  "arts:graphics": { en: "Graphics", cy: "Graffigwaith" },
  "arts:director-notes": {
    en: "Director\u2019s Notes",
    cy: "Nodiadau Cyfarwyddwr",
  },
  "arts:notes": { en: "Notes", cy: "Nodiadau" },
  location: { en: "Location", cy: "Lleoliad" },
  locations: { en: "Locations", cy: "Lleoliadau" },
  base: { en: "Base", cy: "Canolfan" },
  "set-or-facility": { en: "Set\/Facility", cy: "Set\/Cyfleuster" },
  "card-number": { en: "Card Number", cy: "Rhif Cardyn" },
  cameras: { en: "Cameras", cy: "Camerau" },
  camera: { en: "Camera", cy: "Camera" },
  "pa:sound": { en: "Sound", cy: "Sain" },
  "pa:slate": { en: "Slate", cy: "Llechen" },
  shot: { en: "Shot", cy: "Saethiad" },
  sync: { default: "Sync" },
  mute: { default: "Mute" },
  wildtrack: { default: "Wildtrack" },
  guidetrack: { default: "Guidetrack" },
  "pa:takes": { en: "Takes", cy: "Cynigion" },
  take: { en: "Take", cy: "Cynnig" },
  timecode: { default: "Timecode" },
  details: { en: "Details", cy: "Manylion" },
  length: { en: "Length", cy: "Hyd" },
  "pa:description": { en: "Description", cy: "Disgrifiad" },
  "pa:dialogue": { en: "Dialogue", cy: "Deialog" },
  "pa:notes-for-the-editor": {
    en: "Notes for the Editor",
    cy: "Nodiadau i\u2019r Golygydd",
  },
  "pa:sound-details": { en: "Sound Details", cy: "Manylion Sain" },
  script: { en: "Script", cy: "Sgript" },
  "select-script-starting-point": {
    en: "Tap on the script to select a starting point",
    cy: "Tapiwch ar y sgript i ddethol man cychwyn",
  },
  "select-script-new-starting-point": {
    en: "Tap on the script to select a new starting point",
    cy: "Tapiwch ar y sgript i ddethol man cychwyn newydd",
  },
  "select-script-ending-point": {
    en: "Tap on the script to select an ending point",
    cy: "Tapiwch ar y sgript i ddethol man gorffen",
  },
  "select-script-new-ending-point": {
    en: "Tap on the script to select a new ending point",
    cy: "Tapiwch ar y sgript i ddethol man gorffen newydd",
  },
  in: { en: "IN", cy: "MEWN" },
  out: { en: "OUT", cy: "ALLAN" },
  pref: { en: "\u2605", cy: "\u2605" },
  import: { en: "Import", cy: "Llwytho" },
  "import-all": { en: "Import All", cy: "Llwytho Popeth" },
  importing: { en: "Importing", cy: "Llwytho" },
  "importing-all": { en: "Importing All\u2026", cy: "Llwytho Popeth\u2026" },
  "import-complete": { en: "Import complete", cy: "Wedi gorffen llwytho" },
  "import-file": { en: "Import File", cy: "Llwytho Ffeil" },
  "import-files": { en: "Import Files", cy: "Llwytho Ffeiliau" },
  upload: { en: "Upload", cy: "Llwytho" },
  "uploads-not-possible": {
    en: "Uploads are only possible from a computer. Please ask your team for assistance.",
    cy: "Dim ond o gyfrifiadur mae modd llwytho ffeiliau i mewn. Gofynnwch i\u2019ch t\u00eem am gymorth.",
  },
  "upload-started-by": {
    en: (m) => "This upload was started on " + m.datetime + " by " + m.user,
    cy: (m) =>
      "Dechreuodd " + m.user + " uwchlwytho'r eitem hon ar " + m.datetime,
  },
  "check-with-them-retry-prompt": {
    en: "Please check with them whether they need to re-try",
    cy: "Mae\u2019n bosib fod angen iddyn nhw roi cynnig arall arni",
  },
  "drag-prompt": {
    en: (m) => "Drag " + m.fileTypeList + " files here",
    cy: (m) => "Llusgwch ffeiliau " + m.fileTypeList + " yma",
  },
  "only-file-types-error": {
    en: (m) => "Only " + m.fileTypeList + " files can be dragged here",
    cy: (m) => "Dim ond " + m.fileTypeList + " sy\u2019n medru cael eu llusgo",
  },
  or: { en: "or", cy: "neu" },
  "choose-files": { en: "Choose Files\u2026", cy: "Dewis Ffeiliau\u2026" },
  retry: { en: "Retry", cy: "Ail-gynnig" },
  "re-send": { en: "Re-send", cy: "Ail-anfon" },
  load: { en: "Load", cy: "Llwytho" },
  "rename-to": { en: "Rename to\u2026", cy: "Ail-enwi i\u2026" },
  block: { en: "Block", cy: "Bloc" },
  hide: { en: "Hide", cy: "Cuddio" },
  show: { en: "Show", cy: "Dangos" },
  "app-version": { en: "Atgof Version", cy: "Fersiwn Atgof" },
  "software-update-prompt": {
    en: "A new version of Atgof is available",
    cy: "Mae fersiwn newydd o Atgof ar gael",
  },
  close: { en: "Close", cy: "Cau" },
  "reopen-app-prompt": {
    en: "Please close and re-open Atgof to load the latest version",
    cy: "Caewch ac ail-agor Atgof i lwytho\u2019r fersiwn newydd",
  },
  "check-for-updates": { en: "Check for Updates", cy: "Adnewyddu" },
  downloads: { en: "Downloads", cy: "Lawrlwythiadau" },
  download: { en: "Download", cy: "Lawrlwytho" },
  "created-by": { en: "Created by", cy: "Cr\u00ebwyd gan" },
  "created-at": { en: "Created at", cy: "Cr\u00ebwyd" },
  "last-modified": { en: "Last modified", cy: "Newidiad diweddaraf" },
  teaser: { en: "Teaser", cy: "Rhagflas" },
  breakdown: { en: "Breakdown", cy: "Breakdown" },
  timeline: { en: "Timeline", cy: "Llinell Amser" },
  timings: { en: "Timings", cy: "Amseru" },
  "timings:pa": { en: "PA", cy: "PA" },
  "timings:rehearsal": { en: "Rehearsal", cy: "Ymarfer" },
  "timings:shot": { en: "Shot", cy: "Saethu" },
  "timings:edit": { en: "Edit", cy: "Golygu" },
  total: { en: "Total", cy: "Cyfanswm" },
  "running-total": { en: "Running Total", cy: "Cyfanswm wrth fynd" },
  "call-sheets": { en: "Call Sheets", cy: "Call Sheets" },
  "call-sheet": { en: "Call Sheet", cy: "Call Sheet" },
  "d-r": { en: "D\/R", cy: "D\/R" },
  "arrive-short": { en: "Arr", cy: "Cyrr" },
  costume: { en: "Costume", cy: "Gwisg" },
  "hair-mu": { en: "Hair \/ MU", cy: "Gwallt \/ Col." },
  travel: { en: "Travel", cy: "Teithio" },
  schedule: { en: "Schedule", cy: "Amserlen" },
  team: { en: "Team", cy: "T\u00eem" },
  teams: { en: "Teams", cy: "Timau" },
  "default-team": { en: "Default Team", cy: "Criw Diofyn" },
  synchronising: { en: "Synchronising", cy: "Wrthi\u2019n trosglwyddo" },
  "waiting-to-synchronise": {
    en: "Waiting to synchronise",
    cy: "Aros i drosglwyddo newidiadau",
  },
  "synchronising-your-changes": {
    en: "Synchronising your changes\u2026",
    cy: "Trosglwyddo\u2019ch newidiadau\u2026",
  },
  "no-internet-connection": {
    en: "No internet connection",
    cy: "Dim cysylltiad i\u2019r rhyngrwyd",
  },
  "count-file": {
    en: (m) => (m.count == 1 ? "file" : "files"),
    cy: (_) => "ffeil",
  },
  "count-thumbnail": {
    en: (m) => (m.count == 1 ? "thumbnail" : "thumbnails"),
    cy: (_) => "bach",
  },
  "full-size": { en: "full size", cy: "maint llawn" },
  uploading: { en: "Uploading", cy: "Lanlwytho" },
  "waiting-to-upload": { en: "Waiting to upload", cy: "Aros i lanlwytho" },
  "failed-to-upload": { en: "Failed to upload", cy: "Methu lanlwytho" },
  downloading: { en: "Downloading", cy: "Lawrlwytho" },
  "waiting-to-download": { en: "Waiting to download", cy: "Aros i lawrlwytho" },
  "generate-pdf": { en: "Generate PDF", cy: "Creu PDF" },
  "generate-postProduction-pdf": {
    en: "Generate Post-Production PDF",
    cy: "Creu PDF \u00d4l-gynhyrchu",
  },
  "generating-pdf": { en: "Generating PDF", cy: "Wrthi\u2019n creu PDF" },
  "unable-to-generate-pdf": {
    en: "Unable to generate PDF",
    cy: "Methu \u00e2 chreu PDF",
  },
  "generated-pdf": { en: "Generated PDF", cy: "Wedi creu PDF" },
  "download-pdf": { en: "Download PDF", cy: "Lawrlwytho PDF" },
  "generate-call-sheet-elements": {
    en: "Generate Call Sheet Elements",
    cy: "Creu Elfennau Call Sheet",
  },
  "generating-document": {
    en: "Generating document",
    cy: "Wrthi\u2019n creu\u2019r ddogfen",
  },
  "unable-to-generate-document": {
    en: "Unable to generate document",
    cy: "Methu \u00e2 chreu\u2019r ddogfen",
  },
  "generated-document": {
    en: "Generated the document",
    cy: "Wedi creu\u2019r ddogfen",
  },
  "download-document": {
    en: "Download document",
    cy: "Lawrlwytho\u2019r ddogfen",
  },
  "unable-to-import": { en: "Unable to import", cy: "Methu \u00e2 llwytho" },
  "unable-to-import-scripts": {
    en: "Atgof was unable to import scripts for the following scenes:",
    cy: "Nid oedd modd i Atgof lwytho sgriptiau ar gyfer y golygfeydd canlynol:",
  },
  "new-scripts-available": {
    en: "New scripts available in Atgof",
    cy: "Sgriptiau newydd ar gael yn Atgof",
  },
  "new-scripts-available-for-scenes": {
    en: "New scripts are available in Atgof for the following scenes:",
    cy: "Mae sgriptiau newydd ar gael yn Atgof ar gyfer y golygfeydd canlynol:",
  },
  "back-to": { en: "Back to", cy: "Yn \u00f4l at" },
  "on-to": { en: "On to", cy: "Ymlaen at" },
  unscheduled: { en: "Unscheduled", cy: "Heb eu hamserlennu" },
  layers: { en: "Layers", cy: "Haenau" },
  tramlines: { en: "Tramlines", cy: "Tramlines" },
  "ready-for-edit": { en: "Ready for Edit", cy: "Barod i\u2019w Olygu" },
  "edit-complete": { en: "Edited", cy: "Wedi Golygu" },
  "reactGrid-legacyBrowserHeader": {
    en: "Please use a more up-to-date web browser",
    cy: "Defnyddiwch borwr gwe mwy diweddar",
  },
  "reactGrid-legacyBrowserText": {
    en: "Please make sure you browser is fully updated or try a different browser. We recommend using the most recent release of Google Chrome, Microsoft Edge, Firefox or Safari.",
    cy: "Gwnewch yn si\u0175r eich bod yn defnyddio porwr gwe digon diweddar. Rydym yn argymell defnyddio fersiwn ddiweddaraf Google Chrome, Microsoft Edge, Firefox neu Safari.",
  },
  "reactGrid-macOsContextMenuPasteAlert": {
    en: "Use \u2318 C for copy, \u2318 X for cut, and \u2318 V for paste.",
    cy: "Defnyddiwch \u2318 C i gop\u00efo, \u2318 X i dorri, a \u2318 V i ludo.",
  },
  "reactGrid-otherBrowsersContextMenuPasteAlert": {
    en: "Use Ctrl-C for copy, Ctrl-X for cut, and Ctrl-V for paste.",
    cy: "Defnyddiwch Ctrl-C i gop\u00efo, Ctrl-X i dorri, a Ctrl-V i ludo.",
  },
  "reactGrid-contextMenuPasteAlert": {
    en: "This action is not supported in this browser.",
    cy: "Nid oes modd i\u2019ch porwr gwe presennol gyflawni\u2019r weithred hon.",
  },
  copy: { en: "Copy", cy: "Cop\u00efo" },
  cut: { en: "Cut", cy: "Torri" },
  paste: { en: "Paste", cy: "Gludo" },
  unknown: { en: "Unknown", cy: "Anhysbys" },
  uncategorised: { en: "Uncategorised", cy: "Heb Gategori" },
  available: { en: "available", cy: "ar gael" },
  me: { en: "Me", cy: "Fi" },
  everyone: { en: "Everyone", cy: "Pawb" },
  shared: { en: "Shared", cy: "Wedi\u2019i Rannu" },
  private: { en: "Private", cy: "Preifat" },
};
